import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import agenticWorkflowImage from "src/shared/assets/agenticWorkflow.png";

export const AgenticWorkflow: React.FC = () => {
  return (
    <Stack width={1} direction="column" gap={2}>
      <Stack
        width={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          variant="h4"
          color="primary"
          fontWeight={300}
          sx={{
            fontSize: {
              xs: "1.675rem",
              sm: "2.125rem",
            },
          }}
        >
          Agentic{" "}
          <Typography
            component="span"
            variant="inherit"
            color="text.secondary"
            fontWeight="inherit"
          >
            Workflow Integration
          </Typography>
        </Typography>

        <Typography
          maxWidth={0.7}
          color="text.primary"
          variant="body1"
          textAlign="center"
          sx={{
            fontSize: {
              sm: "1rem",
              xs: "0.875rem",
            },
          }}
        >
          By connecting with n8n, WriteBetter can trigger advanced automated AI
          agents that use user-specific knowledge through simple command
          execution directly on incoming messages.
        </Typography>
      </Stack>

      <Box
        width={1}
        component="img"
        src={agenticWorkflowImage}
        alt="agenticWorkflowImage"
        sx={{
          objectFit: "contain",
          overflow: "hidden",
        }}
      />
    </Stack>
  );
};
